export const table = {
    namespaced: true,
    state: {
        params: {
            sortBy: {
                value: null,
                dir: 'asc'
            }
        },
        observedFilters: []
    },

    getters: {
        getParams: state => state.params,
        /**
         * Retorna os filtros observados em uma listagem
         *
         * @param {Object} state Estado do vuex para as tabelas do sistema
         * @returns 
         */
        getObservedFilters(state) {
            return state.observedFilters
        },
        /**
         * Retorna o resultado da verificação de se existem filtros observados em uma
         * listagem
         *
         * @param {Object} state Estado do vuex para as tabelas do sistema
         * @returns 
         */
        getHasObservedFilters(state) {
            return !!state.observedFilters.length
        }
    },

    mutations: {
        SET_SORT_BY(state, payload) {
            state.params.sortBy = { ...payload }
        },
        OBSERVE_FILTERS(state, payload) {
            state.observedFilters = [ ...payload ]
        }
    },

    actions: {
        setSortBy({ commit }, payload) {
            commit('SET_SORT_BY', payload)
        },
        /**
         * Seta os filtros recebidos como os parâmetros 
         * @param {*} payload 
         */
        observeFilters({ commit }, payload) {
            commit('OBSERVE_FILTERS', payload)
        }
    }
}